import React from "react";
import { Link } from "react-router-dom";
import "./SalesPolicyPage.css";

// Policy Icons
function ShieldIcon({ size = 24, color = "#d19e90" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
    </svg>
  );
}

function AlertTriangleIcon({ size = 24, color = "#d19e90" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
      <line x1="12" y1="9" x2="12" y2="13"/>
      <line x1="12" y1="17" x2="12.01" y2="17"/>
    </svg>
  );
}

function CheckCircleIcon({ size = 24, color = "#d19e90" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
      <polyline points="22,4 12,14.01 9,11.01"/>
    </svg>
  );
}

function UserIcon({ size = 24, color = "#d19e90" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
      <circle cx="12" cy="7" r="4"/>
    </svg>
  );
}

function HeartIcon({ size = 24, color = "#d19e90" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
    </svg>
  );
}

export default function SalesPolicyPage() {
  return (
    <div className="mariamly-sales-policy-page">
      {/* Banner Section */}
      <div className="policy-banner">
        <div className="policy-banner-content">
          <h1 className="policy-banner-title">Sales Policy</h1>
          <div className="policy-breadcrumb">
            <Link to="/">Home</Link>
            <span>/</span>
            <span>Sales Policy</span>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="policy-content">
        {/* Introduction Section */}
        <div className="policy-intro">
          <div className="intro-content">
            <h2>Sales Policy – Mariamly Luxe</h2>
            <p className="intro-lead">
              At Mariamly Luxe, we are committed to providing high-quality makeup, skincare, and haircare products. To ensure transparency and protect both our brand and our valued customers, please read our sales policy carefully before making a purchase.
            </p>
          </div>
          <div className="intro-image">
            <div className="image-placeholder">
              <ShieldIcon size={48} color="#d19e90" />
            </div>
          </div>
        </div>

        {/* Product Use & Responsibility Section */}
        <div className="policy-section">
          <div className="section-header">
            <div className="section-icon">
              <UserIcon size={40} />
            </div>
            <h3>Product Use & Responsibility</h3>
          </div>
          <div className="section-content">
            <div className="policy-points">
              <div className="policy-point">
                <CheckCircleIcon size={24} />
                <p>All products available on Mariamly Luxe are for personal cosmetic use only.</p>
              </div>
              <div className="policy-point">
                <CheckCircleIcon size={24} />
                <p>Results may vary depending on individual skin type, hair type, or usage.</p>
              </div>
              <div className="policy-point">
                <CheckCircleIcon size={24} />
                <p>Customers are advised to read the ingredients list carefully before purchase to avoid potential allergies or sensitivities.</p>
              </div>
              <div className="policy-point">
                <CheckCircleIcon size={24} />
                <p>By purchasing from Mariamly Luxe, you acknowledge that you are responsible for ensuring the product is suitable for your personal use.</p>
              </div>
            </div>
          </div>
        </div>

        {/* Liability Disclaimer Section */}
        <div className="policy-section disclaimer-section">
          <div className="section-header">
            <div className="section-icon">
              <AlertTriangleIcon size={40} />
            </div>
            <h3>Liability Disclaimer</h3>
          </div>
          <div className="section-content">
            <div className="policy-points">
              <div className="policy-point">
                <AlertTriangleIcon size={24} />
                <p>Mariamly Luxe is not liable for any adverse reactions, skin irritations, or side effects that may occur as a result of products retailed on our website.</p>
              </div>
              <div className="policy-point">
                <HeartIcon size={24} />
                <p>If you have sensitive skin, existing conditions, or allergies, we recommend consulting a dermatologist or healthcare professional before use.</p>
              </div>
              <div className="policy-point">
                <AlertTriangleIcon size={24} />
                <p>Discontinue use immediately if irritation occurs and seek medical advice if necessary.</p>
              </div>
            </div>
          </div>
        </div>

        {/* Important Notice */}
        <div className="important-notice">
          <div className="notice-content">
            <div className="notice-icon">
              <ShieldIcon size={32} />
            </div>
            <div className="notice-text">
              <h4>Important Notice</h4>
              <p>
                Your safety and satisfaction are our top priorities. We encourage all customers to perform patch tests before using new products and to consult with healthcare professionals if you have any concerns about product suitability.
              </p>
            </div>
          </div>
        </div>

        {/* Contact Information */}
        <div className="contact-section">
          <div className="contact-content">
            <h3>Questions About Our Sales Policy?</h3>
            <p>
              If you have any questions about our sales policy or need assistance with product selection, our customer service team is here to help.
            </p>
            <div className="contact-buttons">
              <Link to="/contact" className="contact-button primary">
                <HeartIcon size={20} />
                <span>Contact Us</span>
              </Link>
              <Link to="/shop" className="contact-button secondary">
                <CheckCircleIcon size={20} />
                <span>Shop Now</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
